// React Imports
import React from "react";

// Component Imports
import RoutesClient from "./components/RoutesClient";

// CSS Imports
import "./App.css";

function App() {
  return (
    <div>
      <RoutesClient />
    </div>
  );
}

export default App;
